module.exports = __webpack_public_path__ + "static/media/SettingsInactive.84f57732.png";